import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category?category=movie" },
  { label: "电视剧", to: "/category?category=tv" },
  { label: "综艺", to: "/category?category=variety" },
];

const specialItems = [
  { label: "电影专题", to: "/special/movie", icon: "ri-film-line" },
  { label: "电视剧专题", to: "/special/tv", icon: "ri-tv-2-line" },
  { label: "综艺专题", to: "/special/variety", icon: "ri-mic-line" },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [specialOpen, setSpecialOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/80 bg-background-50/95 backdrop-blur-md">
      <div className="mx-auto flex h-16 w-full max-w-[1280px] items-center justify-between gap-4 px-4 md:h-[72px] md:px-8">
        <Link to="/" className="flex shrink-0 items-center gap-2" aria-label="羞羞首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-movie-2-fill text-lg" aria-hidden="true" />
          </span>
          <span className="font-heading text-2xl font-black tracking-tight text-foreground-950">
            羞羞
          </span>
        </Link>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                [
                  "rounded-md px-4 py-2 text-sm font-medium transition-colors",
                  isActive && item.to === "/"
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100 hover:text-primary-700",
                ].join(" ")
              }
            >
              {item.label}
            </NavLink>
          ))}

          <div
            className="relative"
            onMouseEnter={() => setSpecialOpen(true)}
            onMouseLeave={() => setSpecialOpen(false)}
          >
            <button
              type="button"
              className="flex items-center gap-1 rounded-md px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700"
              aria-haspopup="true"
              aria-expanded={specialOpen}
            >
              专题
              <i className="ri-arrow-down-s-line text-base" aria-hidden="true" />
            </button>
            {specialOpen && (
              <div className="absolute left-0 top-full w-48 pt-2">
                <div className="animate-fade-in overflow-hidden rounded-lg border border-background-200 bg-background-50 py-1 shadow-sm">
                  {specialItems.map((s) => (
                    <Link
                      key={s.to}
                      to={s.to}
                      className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 transition-colors hover:bg-primary-50 hover:text-primary-700"
                    >
                      <i className={`${s.icon} text-base text-accent-500`} aria-hidden="true" />
                      {s.label}
                    </Link>
                  ))}
                </div>
              </div>
            )}
          </div>

          <NavLink
            to="/about"
            className="rounded-md px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700"
          >
            关于我们
          </NavLink>
        </nav>

        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => navigate("/search")}
            className="hidden items-center gap-2 rounded-md border border-background-300 bg-background-50 px-3 py-2 text-sm text-foreground-500 transition-colors hover:border-primary-300 hover:text-primary-700 md:flex"
            aria-label="搜索影视资讯"
          >
            <i className="ri-search-line text-base" aria-hidden="true" />
            <span className="whitespace-nowrap">搜索影视资讯</span>
          </button>
          <button
            type="button"
            onClick={() => navigate("/search")}
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-700 transition-colors hover:bg-background-100 md:hidden"
            aria-label="搜索"
          >
            <i className="ri-search-line text-xl" aria-hidden="true" />
          </button>
          <button
            type="button"
            onClick={() => setMobileOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 transition-colors hover:bg-background-100 lg:hidden"
            aria-label="打开菜单"
            aria-expanded={mobileOpen}
          >
            <i className={mobileOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} aria-hidden="true" />
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="animate-fade-in border-t border-background-200 bg-background-50 lg:hidden">
          <nav className="mx-auto flex w-full max-w-[1280px] flex-col px-4 py-3" aria-label="移动端导航">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                onClick={() => setMobileOpen(false)}
                className="rounded-md px-3 py-3 text-base font-medium text-foreground-800 transition-colors hover:bg-background-100"
              >
                {item.label}
              </Link>
            ))}
            <div className="px-3 py-2 text-xs font-semibold uppercase tracking-wide text-foreground-400">
              专题
            </div>
            {specialItems.map((s) => (
              <Link
                key={s.to}
                to={s.to}
                onClick={() => setMobileOpen(false)}
                className="flex items-center gap-3 rounded-md px-3 py-3 text-base text-foreground-700 transition-colors hover:bg-background-100"
              >
                <i className={`${s.icon} text-base text-accent-500`} aria-hidden="true" />
                {s.label}
              </Link>
            ))}
            <Link
              to="/about"
              onClick={() => setMobileOpen(false)}
              className="rounded-md px-3 py-3 text-base font-medium text-foreground-800 transition-colors hover:bg-background-100"
            >
              关于我们
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}